var _g, _path, _rect, _g2, _rect2, _g3, _rect3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPage2Bar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 33,
    viewBox: "0 0 369 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_2138)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 15,
    fill: "#004068",
    stroke: "#004068",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.078 20.142L22.72 10.5L24.0003 11.7802L13.078 22.7025L7.99976 17.6257L9.28001 16.3455L13.078 20.142Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 15.5,
    width: 80,
    height: 2,
    fill: "#004068"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9_2138)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 16.5,
    r: 15,
    fill: "white",
    stroke: "#004068",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 16.5,
    r: 5.5,
    fill: "#EA7024"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 15.5,
    width: 80,
    height: 2,
    fill: "#969696"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_9_2138)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 16.5,
    r: 15,
    fill: "white",
    stroke: "#969696",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.316 21.157C235.586 21.1539 234.963 20.9615 234.446 20.5799C233.929 20.1983 233.534 19.6428 233.26 18.9134C232.986 18.1839 232.849 17.3053 232.849 16.2773C232.849 15.2525 232.986 14.3769 233.26 13.6506C233.537 12.9242 233.934 12.3703 234.451 11.9886C234.971 11.607 235.592 11.4162 236.316 11.4162C237.039 11.4162 237.659 11.6085 238.176 11.9933C238.693 12.3749 239.089 12.9289 239.363 13.6552C239.64 14.3784 239.778 15.2525 239.778 16.2773C239.778 17.3084 239.641 18.1886 239.367 18.918C239.093 19.6443 238.698 20.1998 238.181 20.5845C237.664 20.9661 237.042 21.157 236.316 21.157ZM236.316 19.9244C236.956 19.9244 237.456 19.612 237.816 18.9872C238.179 18.3625 238.361 17.4592 238.361 16.2773C238.361 15.4925 238.278 14.8293 238.112 14.2876C237.948 13.7429 237.713 13.3305 237.405 13.0504C237.101 12.7673 236.737 12.6257 236.316 12.6257C235.679 12.6257 235.179 12.9396 234.815 13.5675C234.452 14.1953 234.269 15.0986 234.266 16.2773C234.266 17.0652 234.348 17.7315 234.511 18.2763C234.677 18.8179 234.912 19.2288 235.217 19.5089C235.522 19.7859 235.888 19.9244 236.316 19.9244ZM244.707 21.1293C244.073 21.1293 243.507 21.02 243.008 20.8015C242.513 20.583 242.121 20.2798 241.831 19.892C241.545 19.5012 241.391 19.0488 241.37 18.5348H242.819C242.838 18.8149 242.932 19.058 243.101 19.2642C243.273 19.4673 243.498 19.6243 243.775 19.7351C244.052 19.8459 244.36 19.9013 244.698 19.9013C245.071 19.9013 245.4 19.8366 245.686 19.7074C245.975 19.5781 246.202 19.3981 246.365 19.1673C246.528 18.9334 246.609 18.6641 246.609 18.3594C246.609 18.0424 246.528 17.7638 246.365 17.5238C246.205 17.2807 245.969 17.0898 245.658 16.9513C245.351 16.8129 244.978 16.7436 244.541 16.7436H243.742V15.5803H244.541C244.892 15.5803 245.2 15.5172 245.464 15.391C245.732 15.2648 245.941 15.0894 246.092 14.8647C246.243 14.637 246.318 14.3707 246.318 14.0661C246.318 13.7737 246.252 13.5198 246.12 13.3043C245.991 13.0858 245.806 12.915 245.566 12.7919C245.329 12.6688 245.049 12.6072 244.726 12.6072C244.418 12.6072 244.13 12.6642 243.863 12.7781C243.598 12.8888 243.382 13.0489 243.216 13.2582C243.05 13.4644 242.961 13.7121 242.948 14.0014H241.568C241.584 13.4905 241.734 13.0412 242.021 12.6534C242.31 12.2656 242.691 11.9625 243.165 11.744C243.639 11.5254 244.166 11.4162 244.744 11.4162C245.351 11.4162 245.874 11.5347 246.314 11.7717C246.757 12.0056 247.099 12.3179 247.339 12.7088C247.582 13.0997 247.702 13.5275 247.699 13.9922C247.702 14.5215 247.554 14.9709 247.256 15.3402C246.96 15.7095 246.566 15.9573 246.074 16.0835V16.1573C246.702 16.2527 247.188 16.502 247.533 16.9052C247.88 17.3084 248.053 17.8085 248.05 18.4055C248.053 18.9257 247.908 19.3919 247.616 19.8043C247.326 20.2167 246.931 20.5414 246.429 20.7784C245.928 21.0123 245.354 21.1293 244.707 21.1293Z",
    fill: "#969696"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 256.5,
    y: 15.5,
    width: 80,
    height: 2,
    fill: "#969696"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_9_2138)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 352.5,
    cy: 16.5,
    r: 15,
    fill: "white",
    stroke: "#969696",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.252 21.157C347.523 21.1539 346.9 20.9615 346.383 20.5799C345.866 20.1983 345.47 19.6428 345.196 18.9134C344.922 18.1839 344.785 17.3053 344.785 16.2773C344.785 15.2525 344.922 14.3769 345.196 13.6506C345.473 12.9242 345.87 12.3703 346.387 11.9886C346.907 11.607 347.529 11.4162 348.252 11.4162C348.976 11.4162 349.596 11.6085 350.113 11.9933C350.63 12.3749 351.025 12.9289 351.299 13.6552C351.576 14.3784 351.715 15.2525 351.715 16.2773C351.715 17.3084 351.578 18.1886 351.304 18.918C351.03 19.6443 350.634 20.1998 350.117 20.5845C349.6 20.9661 348.979 21.157 348.252 21.157ZM348.252 19.9244C348.892 19.9244 349.393 19.612 349.753 18.9872C350.116 18.3625 350.297 17.4592 350.297 16.2773C350.297 15.4925 350.214 14.8293 350.048 14.2876C349.885 13.7429 349.65 13.3305 349.342 13.0504C349.037 12.7673 348.674 12.6257 348.252 12.6257C347.615 12.6257 347.115 12.9396 346.752 13.5675C346.389 14.1953 346.206 15.0986 346.203 16.2773C346.203 17.0652 346.284 17.7315 346.447 18.2763C346.613 18.8179 346.849 19.2288 347.154 19.5089C347.458 19.7859 347.824 19.9244 348.252 19.9244ZM353.154 19.1534V17.9993L357.239 11.5455H358.149V13.2443H357.572L354.65 17.87V17.9439H360.249V19.1534H353.154ZM357.636 21V18.8026L357.646 18.2763V11.5455H358.998V21H357.636Z",
    fill: "#969696"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_2138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9_2138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(112.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_9_2138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(224.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_9_2138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(336.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage2Bar);
export default __webpack_public_path__ + "static/media/page2bar.9f0f9239a4d90c0de5e81335ef8f1e6e.svg";
export { ForwardRef as ReactComponent };